import { render, staticRenderFns } from "./Pir.vue?vue&type=template&id=ae8a1b2e&scoped=true&"
import script from "./Pir.vue?vue&type=script&lang=js&"
export * from "./Pir.vue?vue&type=script&lang=js&"
import style0 from "./Pir.vue?vue&type=style&index=0&id=ae8a1b2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8a1b2e",
  null
  
)

export default component.exports